<template lang="html">
  <button :aria-label="$slots.default[0].text" class="prt-button" :class="{'icon-left': iconLeft, 'icon-right': iconRight}" :disabled="disabled">
    <prt-icon :icon="iconLeft" v-if="iconLeft" />
    <span>{{$slots.default[0].text}}</span>
    <prt-icon :icon="iconRight" v-if="iconRight" />
  </button>
</template>

<script>
import PrtIcon from './PrtIcon.vue';

export default {
  components: {
    PrtIcon,
  },
  props: {
    disabled: Boolean,
    iconLeft: String,
    iconRight: String,
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-button
    font-family: inherit
    font-size: inherit
    font-weight: normal
    color: inherit
    background-color: white
    box-shadow: 0 2px 4px black-12
    border: none
    outline: none
    border-radius: 20px
    height: 40px
    padding: 11px 20px
    margin: 8px
    margin-top: 0px
    cursor: pointer
    -webkit-tap-highlight-color: transparent
    transition: background-color 200ms ease, color 200ms ease, box-shadow 200ms ease

    &[disabled]
      box-shadow: none
      background-color: white-70
      color: black-54
      cursor: default

    span
      line-height: 18px
      vertical-align: top
      pointer-events: none

    &.icon-left
      padding-left: 11px

      .prt-icon
        margin-right: 11px

    &.icon-right
      padding-right: 11px

      .prt-icon
        margin-left: 11px

    &:active
      background-color: positive
      color: white
</style>
